import { NumberFormatStyle } from '@shared/utils/constants';

export const buildExportPnlBaseSection = (
	sectionTitle: string, 
	headerRow: string[]
) => {

	return [
		[sectionTitle],
		headerRow,
	];
};

export const formatPercent = (value: number, notation: NumberFormatStyle) => {
	if (!isFinite(value)) {
		return '';
	}

	// behold negativt nul?
	const isNegative = Object.is(value, -0) || value < 0;

	const numberValue = Math.abs(value).toFixed(2);

	const formattedValue = notation === NumberFormatStyle.European ? numberValue.replace('.', ',') : numberValue;

	return (isNegative ? '-' : '') + formattedValue;
};

export	const handleNotation = (value: number, notation: NumberFormatStyle) => {
	if (value == null || !isFinite(value)) {
		return '';
	}

	const fixed = value.toFixed(2);

	return notation === NumberFormatStyle.European ? fixed.replace('.', ',') : fixed;
};